/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ACESApplyForBenefits.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_ACES_ONLINE_CATEGORIES_CHAP_3 = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `ACESAPPLYFORBENEFITS/FETCH_ACES_ONLINE_CATEGORIES_CHAP_3`
);

export { FETCH_ACES_ONLINE_CATEGORIES_CHAP_3 };
